import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    IsChargingPipe,
    IsAvailablePipe,
    IsOccupiedPipe,
    IsPreparingPipe,
    IsFinishingPipe,
    IsUnavailablePipe,
    IsFaultedPipe,
    IsUnknownPipe,
    IsSelfTestPipe,
} from './connector-status.pipe';

@NgModule({
    declarations: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
    ],
    imports: [CommonModule],
    exports: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
    ],
    providers: [
        IsChargingPipe,
        IsAvailablePipe,
        IsUnavailablePipe,
        IsFaultedPipe,
        IsOccupiedPipe,
        IsPreparingPipe,
        IsFinishingPipe,
        IsUnknownPipe,
        IsSelfTestPipe,
    ],
})
export class ConnectorStatusPipesModule {}
